const accordionContainer = document.querySelector(".accordion__container");

if (accordionContainer) {
  accordionContainer.addEventListener("click", (e) => {
    handleAccordionTabsChange();
  });
}

function handleAccordionTabsChange() {
  const accordionImg = document.querySelector(".accordion__img");

  const rd1 = document.getElementById("rd1");
  const rd2 = document.getElementById("rd2");
  const rd3 = document.getElementById("rd3");
  const rd4 = document.getElementById("rd4");

  if (rd1.checked) {
    cleanAccordionClasses();
    accordionImg.classList.add("accordion__img--1");
  }

  if (rd2.checked) {
    cleanAccordionClasses();
    accordionImg.classList.add("accordion__img--2");
  }

  if (rd3.checked) {
    cleanAccordionClasses();
    accordionImg.classList.add("accordion__img--3");
  }

  if (rd4.checked) {
    cleanAccordionClasses();
    accordionImg.classList.add("accordion__img--4");
  }
}

function cleanAccordionClasses() {
  const accordionImg = document.querySelector(".accordion__img");

  accordionImg.classList.remove("accordion__img--1");
  accordionImg.classList.remove("accordion__img--2");
  accordionImg.classList.remove("accordion__img--3");
  accordionImg.classList.remove("accordion__img--4");
}
